module.exports = __webpack_public_path__ + "img/computer7.97bcee73.gif";